import clsx from "clsx";
import type { LegacyRef } from "react";
import { forwardRef } from "react";

import classes from "./styles.module.scss";

import type { IChatMessageProps } from "@components/organisms/videoVisit";
import { getVisitRoleColors } from "@components/organisms/videoVisit";
import { Avatar } from "@components/atoms/avatar";
import { useConvertDate } from "@utils";
import { Typography } from "@components/atoms/typography";

export const ChatMessage = forwardRef(
  (
    {
      name,
      isMyMessage,
      role,
      text,
      datetime,
      avatar,
      firstName,
      lastName,
    }: IChatMessageProps,
    ref: LegacyRef<HTMLDivElement>,
  ) => {
    const { humanizeFullDate } = useConvertDate();

    return (
      <div
        ref={ref}
        className={clsx(classes.message, !isMyMessage && classes.messageOther)}
      >
        <div className={clsx(classes.message__avatar)}>
          <Avatar
            userInfo={{ firstName, lastName, imageUrl: avatar }}
            size={"very-small"}
          />
        </div>
        <div
          className={clsx(
            classes.message__content,
            !isMyMessage && classes.messageOther__content,
          )}
        >
          <Typography fontSize={"md"} fontWeight={"semi-bold"}>
            {name}
          </Typography>
          <div
            className={clsx(
              classes.message__info,
              !isMyMessage && classes.messageOther__info,
            )}
            style={
              isMyMessage ? {} : { backgroundColor: getVisitRoleColors(role) }
            }
          >
            <Typography
              fontSize={"md"}
              fontWeight={"medium"}
              color={"primary-text"}
              className={clsx(classes.message__text)}
            >
              {text}
            </Typography>
            <Typography
              fontSize={"xs"}
              color={"primary-main"}
              fontWeight={"medium"}
              fontFamily={"Morabba"}
            >
              {humanizeFullDate(datetime)}
            </Typography>
          </div>
        </div>
      </div>
    );
  },
);

ChatMessage.displayName = "ChatMessage";
